import { useState } from "react";
import { FiInfo } from "react-icons/fi";
import VulnerabilityModal from "../../modals/VulnerabilityModal";
import CircularScore from "../../../../../components/CircularScore";
import DataTable from "../../../../../components/DataTable";
import ThreatBadge from "../../../../../components/ThreatBadge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../../components/ui/select";
import { severities } from "../../../../../constants";
const Results = ({ results }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [details, setDetails] = useState(null);
  const [threatFilter, setThreatFilter] = useState("");

  const columns = [
    {
      accessorKey: "name",
      header: () => <span>Vulnerability</span>,
      width: "50%",
      cell: ({ row }) => <span>{row.original.name}</span>,
    },
    {
      accessorKey: "threat",
      header: () => <span>Severity</span>,
      width: "15%",
      cell: ({ row }) => (
        <span>
          {" "}
          <ThreatBadge threat={row.original.threat} />
        </span>
      ),
    },
    {
      accessorKey: "severity",
      header: () => <span>CVSS</span>,
      width: "18%",
      cell: ({ row }) => (
        <span>
          {" "}
          <CircularScore score={row.original?.severity} />
        </span>
      ),
    },
    {
      accessorKey: "qod",
      accessorFn: (row) => row.qod?.value || "",
      header: () => <span>QOD</span>,
      width: "12%",
      cell: ({ row }) => <span>{row.original.qod?.value}</span>,
    },
    {
      accessorKey: "host",
      accessorFn: (row) => row.host?.["#text"] || "",
      header: () => <span>Host</span>,
      width: "20%",
      cell: ({ row }) => <span>{row.original.host?.["#text"]}</span>,
    },
    {
      accessorKey: "port",
      header: () => <span>Port</span>,
      width: "20%",
      cell: ({ row }) => <span>{row.original.port}</span>,
    },
    {
      id: "action",
      header: () => <span className="block text-center"></span>,
      width: "8%",
      cell: ({ row }) => {
        const item = row.original;
        return (
          <span className="block text-center">
            <FiInfo
              className="text-blue-600 cursor-pointer"
              onClick={() => {
                setDetails(item);
                setIsOpen(true);
              }}
            />
          </span>
        );
      },
    },
  ];
  return (
    <div>
      {results && results.length > 0 && (
        <>
          <DataTable
            columns={columns}
            data={results}
            externalFilters={{ threat: threatFilter || "" }}
            filtersSlot={
              <>
                <Select
                  value={threatFilter}
                  onValueChange={(value) =>
                    value === "all"
                      ? setThreatFilter("")
                      : setThreatFilter(value)
                  }
                >
                  <SelectTrigger
                    className="w-[120px] rounded-lg h-9"
                    aria-label="Severity"
                  >
                    <SelectValue placeholder="Severity" />
                  </SelectTrigger>
                  <SelectContent className="rounded-xl">
                    {severities.map((item, index) => (
                      <SelectItem
                        value={item.value}
                        key={index}
                        className="rounded-lg"
                      >
                        {item.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </>
            }
          />
        </>
      )}
      {results && results.length === 0 && (
        <div className=" h-[45vh] w-full flex justify-center flex-col items-center text-center">
          <p className=" font-semibold text-xl">There are no results</p>
        </div>
      )}

      <VulnerabilityModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        details={details}
      />
    </div>
  );
};

export default Results;
